const FLOOR_DELETE_DIALOG = 'FLOOR_DELETE_DIALOG';
const FLOOR_CREATE_DIALOG = 'FLOOR_CREATE_DIALOG';
const FLOOR_UPDATE_DIALOG = 'FLOOR_UPDATE_DIALOG';

export default {
    FLOOR_DELETE_DIALOG,
    FLOOR_CREATE_DIALOG,
    FLOOR_UPDATE_DIALOG
};
